import BracketGameTiebreaker from "../BracketGameTiebreaker";
import BracketGameFixtures from "./BracketGameFixtures";

export default class BracketGamePredictionRequestBody {
  public fixtures: BracketGameFixtures[] = [];
  public tiebreaker: BracketGameTiebreaker | null;
}
